import 'lazysizes';
import Alpine from 'alpinejs'
import registerComponents from "./components";
import collapse from '@alpinejs/collapse'
import persist from '@alpinejs/persist'
 
Alpine.plugin(persist)
Alpine.plugin(collapse)

fetch('/kosik.json').then((response) => response.json()).then(cartData => {

    let orderDetails = {
		name: '',
		address: '',
		tel: '',
		email: '',
		note: '',
		payment: '',
		date: ''
	}

    if(localStorage.getItem('cart-version') && JSON.parse(localStorage.getItem('cart-version')) !== cartData.version){
        localStorage.removeItem("cart-items");
        localStorage.removeItem("cart-version");
    }

    Alpine.store('cart', {
        items: Alpine.$persist(cartData.items).as('cart-items'),
        cartVersion: Alpine.$persist(cartData.version).as('cart-version'),
        orderDetails: Alpine.$persist(orderDetails).as('cart-details'),
    });
    
    registerComponents();
    Alpine.start()

})